import clsx from 'clsx';

import DrupalImage from '@commons/components/Image/Drupal';
import RichText from '@commons/components/RichText';
import Separator from '@commons/components/Separator';
import Flex from '@commons/containers/Flex';
import { Link } from '@commons/i18n/navigation';
import type {
  DrupalBlock,
  DrupalImage as DrupalImageType,
  DrupalLink,
} from '@commons/types/drupal';
import type { Alignment, Theme } from '@commons/types/styles';

import styles from './index.module.scss';

// Type definition for the Tile component properties.

type Props = DrupalBlock<{
  body: string;
  icon?: DrupalImageType;
  backgroundImage: DrupalImageType;
  theme: Theme;
  link?: DrupalLink;
  separator?: boolean;
  alignment?: Alignment;
}>;

/**
 * Tile Block component.
 */

const TileBlock = ({ content }: Props) => {
  // THERE IS A COPY OF IT IN paragraphs/ImageTile

  const {
    theme,
    backgroundImage,
    separator = true,
    alignment = 'start',
    icon,
    body,
    link,
  } = content;

  const classes = clsx(styles.iconTile, link && styles.hasLink, 'w-100', 'h-100');

  const renderedCard = (
    <Flex
      theme={theme}
      padding="md"
      justify="space-between"
      direction="column"
      paddingRight={{ xs: 'md', lg: 'lg' }}
      className={classes}
    >
      <Flex direction="column" justify={alignment} className={styles.content}>
        {separator && (
          <Separator dash color="primary" marginBottom="xs" className={styles.separator} />
        )}
        <RichText value={body} />
      </Flex>
      {icon && <DrupalImage {...icon} className={styles.icon} />}
      {backgroundImage && (
        <div className={clsx(styles.backgroundImage, 'h-100', 'w-100')}>
          <DrupalImage {...backgroundImage} />
        </div>
      )}
    </Flex>
  );

  if (link) {
    return <Link href={link.url}>{renderedCard}</Link>;
  }

  return renderedCard;
};

export default TileBlock;
